module.exports = __webpack_public_path__ + "static/media/img_medprod_min.a1ad2347.jpg";